let _delayAction = null;

function action(fnCall, timeout = 1250) {
  clearTimeout(_delayAction);

  _delayAction = setTimeout(fnCall, timeout);
}

function useDelayWorker(fnCall, timeout = 1250) {
  return {
    _worker: null,
    run: () => {
      if (this._worker) clearTimeout(this._worker);

      this._worker = setTimeout(fnCall, timeout);
    },
    cancel: () => {
      if (this._worker) clearTimeout(this._worker);
    },
  };
}

module.exports = {
  action,
  useDelayWorker,
};
